import { render } from "./nirItzhakGeneral.vue?vue&type=template&id=1b6fdc6d&scoped=true"
import script from "./nirItzhakGeneral.vue?vue&type=script&lang=js"
export * from "./nirItzhakGeneral.vue?vue&type=script&lang=js"

import "./nirItzhakGeneral.vue?vue&type=style&index=0&id=1b6fdc6d&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6fdc6d"]])

export default __exports__